import type { HelpFile } from '../../types/help'
import { EnforcementObjectsTestIds } from '../../../testids/EnforcementObjectsTestIds'

export const enforcementObjectsHelp: HelpFile = {
  docPage: '/docs/systems/enforcement-objects',
  texts: {
    [EnforcementObjectsTestIds.enforcementObjectsList]:
      'Enforcement-Objekte in den angebundenen Zielsystemen — die konkreten Zugriffsrechte, die ein Zugriffsprofil vergeben kann.',
    [EnforcementObjectsTestIds.colExternalId]:
      'Die Kennung, mit der das Zielsystem dieses Enforcement-Objekt identifiziert — etwa der LDAP-DN, der Datenbank-Rollenname oder die SCIM-Group-ID. Wird beim Abgleich mit dem führenden System verwendet.',
  },
}
